function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.63636 8.14545c-1.92797 0-3.4909 1.56294-3.4909 3.49091v8.72728c0 1.92797 1.56293 3.4909 3.4909 3.4909h8.72728c1.92797 0 3.4909-1.56293 3.4909-3.4909v-8.72728c0-1.92797-1.56293-3.4909-3.4909-3.4909h-8.72728zm0-1.74545h8.72728C23.2556 6.4 25.6 8.7444 25.6 11.63636v8.72728C25.6 23.2556 23.2556 25.6 20.36364 25.6h-8.72728C8.7444 25.6 6.4 23.2556 6.4 20.36364v-8.72728C6.4 8.7444 8.7444 6.4 11.63636 6.4zm6.99126 9.1782c-.16917-1.14086-1.06496-2.03665-2.20582-2.20582-1.11729-.16568-2.21488.40384-2.7227 1.41275-.5078 1.00892-.31136 2.22976.48733 3.02844.79868.79869 2.01952.99514 3.02844.48732 1.00891-.50781 1.57843-1.6054 1.41275-2.7227zm-1.94979-3.9324c1.90143.28196 3.3944 1.77494 3.67637 3.67637.27613 1.86215-.67307 3.69146-2.3546 4.53782-1.68152.84636-3.71626.51895-5.0474-.8122-1.33114-1.33113-1.65855-3.36587-.8122-5.0474.84637-1.68152 2.67568-2.63072 4.53783-2.35459zm4.55853-.88216c.482 0 .87273.39073.87273.87272 0 .482-.39073.87273-.87273.87273-.48199 0-.87272-.39073-.87272-.87273 0-.48199.39073-.87272.87272-.87272z",
  id: "a"
}));

var _ref3 = /*#__PURE__*/React.createElement("use", {
  fill: "#004E44",
  xlinkHref: "#a",
  transform: "translate(-6 -6)",
  fillRule: "evenodd"
});

var SvgInstaGreen = function SvgInstaGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstaGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instaGreen.22763008.svg";
export { ForwardRef as ReactComponent };